import { createFileRoute } from '@tanstack/react-router'
import { RequireAuth } from '@dss/auth'
import { EmployeesScreen } from '../features/employees/EmployeesScreen'

export const Route = createFileRoute('/employees')({
  component: () => <RequireAuth><EmployeesScreen /></RequireAuth>,
})
